// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"72549682191c4d38","src_app_admin_admin_module_ts":"ae93b5c7018e07e4"}[chunkId] + ".js";
};